import request from '@/utils/request'

// ============ 权益商品管理 ============

export function getRightsGoodsPage(params) {
  return request({
    url: '/admin/rights/goods/page',
    method: 'get',
    params
  })
}

export function getRightsGoodsList(params) {
  return request({
    url: '/admin/rights/goods/list',
    method: 'get',
    params
  })
}

export function getRightsGoodsDetail(id) {
  return request({
    url: `/admin/rights/goods/${id}`,
    method: 'get'
  })
}

export function createRightsGoods(data) {
  return request({
    url: '/admin/rights/goods',
    method: 'post',
    data
  })
}

export function updateRightsGoods(data) {
  return request({
    url: '/admin/rights/goods',
    method: 'put',
    data
  })
}

export function deleteRightsGoods(ids) {
  return request({
    url: '/admin/rights/goods',
    method: 'delete',
    data: ids
  })
}

export function updateRightsGoodsStatus(id, status) {
  return request({
    url: `/admin/rights/goods/${id}/status`,
    method: 'put',
    params: { status }
  })
}

export function getRightsGoodsStatistics(params) {
  return request({
    url: '/admin/rights/goods/statistics',
    method: 'get',
    params
  })
}

export function getOnlineRightsGoods() {
  return request({
    url: '/admin/rights/goods/online',
    method: 'get'
  })
}

export function uploadRightsGoodsImage(data, onUploadProgress) {
  return request({
    url: '/admin/rights/goods/upload',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    timeout: 600000,
    onUploadProgress
  })
}

// ============ 兑换记录管理 ============

export function getRightsExchangePage(params) {
  return request({
    url: '/admin/rights/exchange/page',
    method: 'get',
    params
  })
}

export function getRightsExchangeDetail(id) {
  return request({
    url: `/admin/rights/exchange/${id}`,
    method: 'get'
  })
}

export function exchangeRightsGoods(userId, goodsId) {
  return request({
    url: '/admin/rights/exchange/exchange',
    method: 'post',
    data: { userId, goodsId }
  })
}

export function cancelRightsExchange(id) {
  return request({
    url: `/admin/rights/exchange/${id}/cancel`,
    method: 'put'
  })
}

export function useRightsExchange(id) {
  return request({
    url: `/admin/rights/exchange/${id}/use`,
    method: 'put'
  })
}

export function getUserRightsExchanges(userId) {
  return request({
    url: `/admin/rights/exchange/user/${userId}`,
    method: 'get'
  })
}

export function getRightsExchangeStatistics(params) {
  return request({
    url: '/admin/rights/exchange/statistics',
    method: 'get',
    params
  })
}
